import { render, staticRenderFns } from "./modalFormulasComponent.vue?vue&type=template&id=3da24af2"
import script from "./modalFormulasComponent.vue?vue&type=script&lang=js"
export * from "./modalFormulasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports